import { documentsTypes } from './documents-types';
import axios from "axios";
import swal from "sweetalert2";
import barramento from "../../../../barramento";

export default {
  name: 'documents',
  data() {
    return {
      documentsTypes: documentsTypes,
      files_to_generate: [],
      spinner_button: false,
    }
  },
  props: {
    documents: {
      type: Array,
      default: () => { }
    },
    tags: {
      type: Object,
      default: () => { }
    },
    item: {
      type: Object,
      default: () => { }
    },
    shipmentIndex: null
  },
  methods: {
    filesToGenerate() {
      if (this.tags.has_invoice_label == 0)
        this.files_to_generate.push({ title: 'Gerar nfe', file: 'has_invoice_label' });

      if (this.tags.has_label == 0)
        this.files_to_generate.push({ title: 'Gerar etiqueta', file: 'has_label' });
    },
    documentsAction(tag) {
      switch (tag) {
        case 'has_invoice_label':
          this.gerar_nfes([this.item.id], true, tag);
          break;
        case 'has_label':
          this.print_labels([this.item.id], tag);
          break;
      }
    },
    documentType(documentType) {
      if (this.documentsTypes[documentType] !== undefined) {
        return this.documentsTypes[documentType];
      } else {
        return documentType;
      }
    },
    atualizaPropsItem(tag, url_file) {
      var newItem = this.item;
      newItem.tags[tag] = 2;
      newItem.shipments[shipmentIndex].documents.push({
        url: url_file,
        type: tag == 'has_label' ? 'label' : tag,
      })
      barramento.$emit('edit_atualizar_depois_de_gerar_os_arquivos', newItem);
    },
    gerar_nfes(orders_ids, show_modal, tag) {
      this.spinner_button = tag;
      axios
        .post("/api/documents/get_nfes", orders_ids)
        .then((response) => {
          this.spinner_button = false;
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: response.data.erro,
                type: "error",
              });
            }
          } else {
            this.spinner_button = false;
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.atualizaPropsItem(tag, response.data.file);
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Notas fiscais geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },
    print_labels(orders_ids, tag) {
      this.spinner_button = tag;
      axios
        .post("/api/documents/get_labels", orders_ids)
        .then((response) => {
          this.spinner_button = false;
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              let link = document.createElement("a");
              link.setAttribute("href", pdf_link);
              link.setAttribute("download", pdf_link);
              link.setAttribute("target", "_blank");
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.atualizaPropsItem(tag, pdf_link);
            });
          } else {
            if (response.data.error) {
              if (response.data.error.orders) {
                var text =
                  "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)";

                for (var key in response.data.error.orders) {
                  text = text + "\n" + this.$t("Pedido") + " " + key;
                  for (var key2 in response.data.error.orders[key]) {
                    text = text + "\n" + response.data.error.orders[key][key2];
                  }
                }
              }

              if (response.data.error.config) {
                var text =
                  "Clique no linque abaixopara configurar o formato de impressão.";
              }

              swal({
                title: "Ops!",
                text:
                  "Ocorreu algum problema ao tentar gerar as etiquetas, " +
                  text,
                footer:
                  '<a href="http://beta.plugg.to/settings#labels" target="_parent">Clique aqui<a>',
                type: "error",
              });
            } else {
              swal({
                title: "Ops!",
                text: "Ocorreu algum problema ao tentar gerar as etiquetas do pedido, tente novamente em alguns instantes.",
                type: "error",
              });
            }
          }
          this.spinner_button = false;
        })
        .catch((error) => {
          this.spinner_button = false;
          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error",
          });
        });
    },
  },
  beforeMount() {
    this.filesToGenerate();
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Orders/Shipments/Documents/documents.js